// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o8-1";
export var messageSideRight = "_o8-2";
export var subscribeToBackInStockBubbleContainer = "_o8-0";